import { ErrorHandler, PlatformEnum } from '../utils';
/**
 * 基础适配器抽象类
 * 提供通用的实现和错误处理机制
 */
export class BaseAdapter {
    constructor(config = {}) {
        this.errorHandler = ErrorHandler.getInstance();
        this.config = Object.assign({ enableErrorHandling: true, enableFallback: true, enableDebug: false, defaultViewportSize: { width: 375, height: 667 } }, config);
    }
    // ========== 环境信息 ==========
    get isMobile() {
        return this.env.isMobile;
    }
    get isTouch() {
        return this.env.isTouch;
    }
    /**
     * 判断当前环境是否为Liteapp
     * @returns 是否为Liteapp环境
     */
    isLiteapp() {
        return this.platformType === PlatformEnum.LiteApp;
    }
    // ========== 存储系统 ==========
    get localStorage() {
        return this.safeCall('localStorage', () => this.getDefaultLocalStorage());
    }
    getCookie(name) {
        return this.safeCall('cookie', () => this.getDefaultCookie(name));
    }
    setCookie(options) {
        return this.safeCall('cookie', () => this.setDefaultCookie(options));
    }
    // ========== 网络请求 ==========
    // fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    //   return this.safeCall('fetch', () => this.doDefaultFetch(input, init));
    // }
    // ========== 浏览器对象 ==========
    get navigator() {
        return this.safeCall('navigator', () => this.getDefaultNavigator());
    }
    get location() {
        return this.safeCall('location', () => this.getDefaultLocation());
    }
    /**
     * 检查是否支持某个特性
     * @param feature
     */
    supports(feature) {
        var _a;
        return (_a = this.capabilities[feature]) !== null && _a !== void 0 ? _a : false;
    }
    /**
     * 安全调用API
     * @param apiName
     * @param fn
     * @param fallback
     */
    safeCall(apiName, fn, fallback) {
        if (!this.config.enableErrorHandling) {
            return fn();
        }
        try {
            return fn();
        }
        catch (error) {
            if (this.config.enableFallback && fallback) {
                this.errorHandler.handleFallbackUsed(apiName, this.platformType, 'fallback');
                try {
                    return fallback();
                }
                catch (fallbackError) {
                    return this.errorHandler.handleApiFailed(apiName, this.platformType, fallbackError);
                }
            }
            return this.errorHandler.handleApiFailed(apiName, this.platformType, error);
        }
    }
}
//# sourceMappingURL=base.js.map